export default __webpack_public_path__ + "static/media/img-laptop.41d749d8.png";